(() => {
  const executeScripts = root => {
    root.querySelectorAll('script').forEach(oldScript => {
      const newScript = document.createElement('script');
      for (const attribute of oldScript.attributes) {
        newScript.setAttribute(attribute.name, attribute.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  };

  const hydrate = host => {
    if (host.dataset.stHydrated === 'true') return;
    const payload = host.querySelector(':scope > script[type="application/json"][data-st-deferred-template]');
    if (!payload) return;

    host.dataset.stHydrated = 'true';
    const content = document.createElement('div');
    content.className = 'st-deferred-html__content';
    content.innerHTML = JSON.parse(payload.textContent);
    payload.remove();
    host.prepend(content);
    executeScripts(content);
    host.dispatchEvent(new CustomEvent('st:deferred-html-ready', { bubbles: true }));
  };

  const mount = root => {
    root.querySelectorAll('st-deferred-html:not([data-st-observed])').forEach(host => {
      host.dataset.stObserved = 'true';
      if (!('IntersectionObserver' in window)) {
        hydrate(host);
        return;
      }
      const margin = host.dataset.stDeferredRootMargin || '320px';
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        hydrate(host);
      }, { rootMargin: `${margin} 0px` });
      observer.observe(host);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  } else {
    mount(document);
  }
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
